import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Libs
import { isLiveMallClub } from '@/constants/systemType'

// Components
import LineRewardBadge from '@/components/shared/LineRewardBadge'

// Styles
import useMedia from '@/hooks/useMedia'
import { TicketsData } from '@/hooks/usePromotion'
import { useShowLineRewardBadge } from '@/hooks/useShowLineRewardBadge'
import { getDisplayPriceWithRange } from '@/methods/getDisplayPrice'
import styles from './style.module.scss'
const cx = classnames.bind(styles)
interface IPriceDisplayerProps {
  className?: string
  selectedCoupon: TicketsData | undefined
  minPrice?: number
  maxPrice?: number
  productInfo: any
  filteredItems: any
  isLive: boolean
  promotionPriceRangeData?: any
  amount: number
  extra?: {
    lineStatus?: boolean
    lineOnShelfDate?: string | number
    lineOffShelfDate?: string | number
    [key: string]: any
  }
}

const PriceDisplayer = ({ className, productInfo, filteredItems, isLive, extra }: IPriceDisplayerProps) => {
  const { t } = useTranslation()

  const { isMobile } = useMedia()
  const { displayPrice, displayLabel, displayOrigPrice } = getDisplayPriceWithRange({
    productInfo,
    filteredItems,
    isLive,
  })

  const showLineRewardBadge = useShowLineRewardBadge(extra)

  return (
    <div className={cx('price-displayer', className, { isLiveMallClub })}>
      {/* Live Mall Club 優惠價格 */}
      {isLiveMallClub && (
        <div className={cx('price-displayer-content', { mobile: isMobile })}>
          {displayPrice && (
            <div className={cx('price-displayer-content-description-price', { isLiveMallClub })}>
              <span>{productInfo?.currency}</span> {displayPrice}
            </div>
          )}
        </div>
      )}

      <div className={cx('price-displayer-content')}>
        <div className={cx('price-displayer-content-description', { isLiveMallClub })}>
          {!isLiveMallClub && <p>{t('Common_Original_Price')}</p>}
          <s className={cx('price-displayer-content-description-original-price', { isLiveMallClub })}>
            {isLiveMallClub ? `${productInfo?.currency} ` : ''}
            {displayOrigPrice}
          </s>
          {/* 月銷量 */}
          {/* {isLiveMallClub && productInfo?.saleQuantity > 0 && (
            <div className={cx('price-displayer-content-description-sale-qty')}>
              {t('Product_Monthly_Sold', { amount: productInfo?.saleQuantity })}
            </div>
          )} */}

          {/* 選擇數量{amount} */}
        </div>
      </div>

      {/* Shop 優惠價格 */}
      {!isLiveMallClub && (
        <div className={cx('price-displayer-content', { mobile: isMobile })}>
          {!isLiveMallClub && <div className={cx('price-displayer-content-description', 'red')}>{t(displayLabel)}</div>}
          <div className={cx('price-displayer-content-price-row')}>
            {displayPrice && <div className={cx('price-displayer-content-description-price')}>{displayPrice}</div>}
            {showLineRewardBadge && <LineRewardBadge />}
          </div>
        </div>
      )}
    </div>
  )
}

export default PriceDisplayer
